var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer",class:{ 'multi-column': _vm.footerColumns.length > 1 },attrs:{"id":"footer"}},_vm._l((_vm.footerColumns),function(ref,index){
var column = ref.column;
return _c('div',{key:index,staticClass:"column",domProps:{"innerHTML":_vm._s(_vm.footerTextLinkified(column))}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }